import React from "react";

const QuickLinks: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
      <div className="rounded-xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 p-4">
        <h4 className="font-semibold text-gray-900 dark:text-white">FAQs</h4>
        <p className="text-sm text-gray-600 dark:text-gray-300">Common questions about accounts, syncing and permissions.</p>
      </div>
      <div className="rounded-xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 p-4">
        <h4 className="font-semibold text-gray-900 dark:text-white">Documentation</h4>
        <p className="text-sm text-gray-600 dark:text-gray-300">Setup guides and feature explainers.</p>
      </div>
      <div className="rounded-xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 p-4">
        <h4 className="font-semibold text-gray-900 dark:text-white">System Status</h4>
        <p className="text-sm text-gray-600 dark:text-gray-300">Check if any services are experiencing issues.</p>
      </div>
      <div className="rounded-xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 p-4">
        <h4 className="font-semibold text-gray-900 dark:text-white">Call Support</h4>
        <p className="text-sm text-gray-600 dark:text-gray-300">Mon-Fri, 8am-5pm IST.</p>
      </div>
    </div>
  );
};

export default QuickLinks;
